import React from 'react'
import "./Cartitems.css"
import { useStateValue } from './State'
function Cartitems({title,price,img_url,rating}) {
    const [{cart},dispatch]=useStateValue();
    const rem=()=>{
        dispatch({
            type: "REMOVE_FROM_CART",
            title,
        })
    }
    
    return (
        <div className="items">
            
                <img src={img_url} alt=""  className="img_1"/>
            
            <div className="info">
                
                  <p>{title}</p>
                  <p className="price">
                     <small>$</small>
                     <strong>{price}</strong>
                   </p>
                   <div className="rating_1">
                {Array(rating).fill().map((_,i)=>(<p>🌟</p>))}
                </div>
                 <button className="button" onClick={rem}>Remove Item</button>
            </div>
           
        </div>
    )
}

export default Cartitems
